module.exports = new __parcel__URL__("battlepass_homebase_button.260199ef.png").toString();